/* The Whole Story – mobile menu panel (snippets/twst-menu-drawer.liquid).
   Dawn's <header-drawer> (global.js) still opens/closes the drawer, traps focus and locks scrolling.
   Dawn binds every <button>/<summary> inside the drawer to its own "close sub-panel" logic, so clicks on our
   controls are caught first (capture phase on the panel) and handled here:
   - close button / backdrop → Dawn's closeMenuDrawer()
   - Search → close the menu, open the header search popup
   - Cart → close the menu, open Dawn's cart drawer (falls back to /cart)
   - submenu summaries → native <details> accordion in place (no sliding sub-panel) */
(function () {
  function init(menu) {
    if (menu.dataset.twstBound) return;
    menu.dataset.twstBound = 'true';

    const headerDrawer = menu.closest('header-drawer');
    const toggle = () => headerDrawer && headerDrawer.querySelector(':scope > details > summary');

    const close = (event) => {
      const summary = toggle();
      if (headerDrawer && summary && typeof headerDrawer.closeMenuDrawer === 'function') {
        headerDrawer.closeMenuDrawer(event, summary);
      }
    };

    menu.addEventListener(
      'click',
      (event) => {
        const target = event.target;

        if (target.closest('[data-twst-menu-close]')) {
          event.stopPropagation();
          event.preventDefault();
          close(event);
          return;
        }

        const search = target.closest('[data-twst-menu-search]');
        if (search) {
          event.stopPropagation();
          event.preventDefault();
          close(event);
          // the header can render the search twice (desktop / mobile) – use the visible one
          const opener = [...document.querySelectorAll('details-modal.header__search > details > summary')].find(
            (el) => el.offsetParent !== null || el.getClientRects().length > 0
          );
          // wait for the drawer to start closing so the search modal gets focus
          setTimeout(() => opener && opener.click(), 50);
          return;
        }

        const cartLink = target.closest('[data-twst-menu-cart]');
        if (cartLink) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer || typeof cartDrawer.open !== 'function') return; // normal link to /cart
          event.stopPropagation();
          event.preventDefault();
          close(event);
          setTimeout(() => cartDrawer.open(document.getElementById('cart-icon-bubble') || cartLink), 50);
          return;
        }

        const summary = target.closest('.twst-menu__group > summary');
        if (summary) {
          // let the native <details> toggle; keep Dawn's sub-panel handler out of it
          event.stopPropagation();
          const details = summary.parentElement;
          requestAnimationFrame(() => summary.setAttribute('aria-expanded', details.hasAttribute('open')));
        }
      },
      true
    );

    // "Cart (n)" is rendered once with the page – refresh it after cart changes and whenever the menu opens
    const cartLabel = menu.querySelector('[data-twst-menu-cart-label]');
    if (cartLabel) {
      const setCount = (count) => {
        if (typeof count === 'number') cartLabel.textContent = `${cartLabel.dataset.twstMenuCartLabel} (${count})`;
      };
      const refreshCount = () =>
        fetch(`${window.routes?.cart_url || '/cart'}.js`)
          .then((response) => response.json())
          .then((cart) => setCount(cart.item_count))
          .catch(() => {});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const count = event?.cartData?.item_count;
          if (typeof count === 'number') setCount(count);
          else refreshCount();
        });
      }
      headerDrawer?.querySelector(':scope > details')?.addEventListener('toggle', (event) => {
        if (event.target.open) refreshCount();
      });
    }

    // Esc inside an open accordion: Dawn closes it via closeSubmenu(); keep aria-expanded in sync
    menu.querySelectorAll('.twst-menu__group').forEach((details) => {
      details.addEventListener('toggle', () => {
        details.querySelector('summary')?.setAttribute('aria-expanded', details.open);
      });
    });
  }

  const run = () => document.querySelectorAll('[data-twst-menu]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
